import { BaseDropdownOption } from '../../../common/Dropdown';
import { TRawAssessmentResult } from '../services/validateDescription';

export enum CheckInTypeEnum {
  TICKET = 'ticket',
  AD_HOC = 'adhoc_task',
}

export type CheckInData = {
  id?: string;
  type: CheckInTypeEnum;
  ticketId?: string | undefined;
  title: string;
  description: string;
  hasBlockers: boolean;
  blockers: string;
  wipMaterials: string;
  prevProgress: number;
  progress: number;
  isUpdate?: boolean;
};

export type CheckInFormProps = {
  formState: CheckInData;
  setFormState: React.Dispatch<React.SetStateAction<CheckInData>>;
  tickets: TicketOption[];
  onSubmit: () => Promise<void>;
  isSubmitting: boolean;
  isFormValid: boolean;
  session: number;
  assessment: TAssessmentResults;
  setAssessment: React.Dispatch<React.SetStateAction<TAssessmentResults>>;
  isValidating: boolean;
  setValidationCount: React.Dispatch<React.SetStateAction<number>>;
};

export type TicketOption = BaseDropdownOption & {
  completionPercentage?: number;
  status: string;
};

export type TValidationResult = {
  isValid: boolean;
  errorMessage?: string;
};

export type TTicketCheckIn = {
  id?: string | undefined;
  userId: string;
  checkInType: CheckInTypeEnum;
  checkInId: string | null;
  dailySequence: number;
  description: string;
  ticketId: string | undefined;
  blockers: string;
  wipLinks: string;
  completionPercentage: number;
  title: string | undefined;
  previousCompletionPercentage: number;
};

export type TAdhockCheckIn = {
  title: string;
  id?: string | undefined;
  userId: string;
  checkInType: CheckInTypeEnum;
  checkInId: string | null;
  dailySequence: number;
  description: string;
};

export type TStandUpSummaryResponse = {
  run_id?: string;
  response: {
    summary: Record<string, string[]>;
    blockers: string[];
    error?: string;
  };
};

export type InputData =
  | string
  | number
  | boolean
  | null
  | InputData[]
  | { [key: string]: InputData };

export interface SummaryCheckinProps {
  id: string;
  check_in_time: string;
}

export type TAssessmentResult = TRawAssessmentResult & {
  isAiSuggestionAccepted: boolean;
  input: string;
};

export type TAssessmentResults = {
  results: TAssessmentResult[];
  currentAssessment: TAssessmentResult | null;
};
